import {Component, OnInit} from '@angular/core';
import {Ai_Properties} from '../../_services/_modals/grievance.modal';
import {HttpService} from '../../../common/_services/http.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-app-channel',
  templateUrl: './app-channel.component.html',
  styleUrls: ['./app-channel.component.css']
})
export class AppChannelComponent implements OnInit {
  public data: any;
  public ai_id: any;
  public channel: string;
  public is_spinner_visible = true;
  public value = 50;
  public color = 'primary';
  public ai_prop: any;
  public channels: any;
  public rejectionReason: any;
  public aiProperties: Ai_Properties;
  public ai_general: any;
  public item: any;
  mod_callerid: string;
  public role_perms: any;
  user_role: string;

  constructor(public router: Router,
              private httpService: HttpService,
              public routea: ActivatedRoute) {
    this.routea.queryParams.subscribe(data => {
      this.ai_id = data['ai_id'];
      this.mod_callerid = data['mod_callerid'];
      this.user_role = data['user_role'];
    });
  }

  async ngOnInit() {
    this.is_spinner_visible = true;

    if (this.is_spinner_visible) {
      this.is_spinner_visible = false;
    }
    this.role_perms = await this.httpService.get_perm_roles(this.user_role);
    this.role_perms = JSON.parse(this.role_perms);
    this.item = await this.httpService.getStaticData();
    this.ai_prop = this.item.Items;
    this.aiProperties  = (this.ai_prop[0]);

    this.item = await this.httpService.getGeneral(this.ai_id);
    this.ai_general = this.item.Items;
    if (this.ai_general.length > 0) {
      if (this.ai_general[0].channel)
        this.channels = JSON.parse(this.ai_general[0].channel);
      if (this.ai_general[0].rejection_reason)
        this.rejectionReason = JSON.parse(this.ai_general[0].rejection_reason);
    }
    if (this.is_spinner_visible) {
      this.is_spinner_visible = false;
    }
  }
}
